import * as React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import GridViewIcon from "@mui/icons-material/GridView";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { CARD_WIDTH } from "./ContentResultCard";

interface BrowseAllCardProps {
    onBrowseAll: () => void;
}

/**
 * The fixed trailing card in the Ask Volley result carousel: a ghost/outlined
 * tile that always renders last and routes to the full workouts library. Visually
 * distinct from the (white) content cards so it reads as a secondary "see
 * everything" action rather than another recommendation.
 */
export default function BrowseAllCard({
    onBrowseAll,
}: BrowseAllCardProps): React.JSX.Element {
    return (
        <Box
            component="button"
            type="button"
            onClick={onBrowseAll}
            aria-label="Browse all workouts"
            sx={{
                flex: `0 0 ${CARD_WIDTH}px`,
                width: CARD_WIDTH,
                scrollSnapAlign: "start",
                cursor: "pointer",
                p: 0,
                border: "1px dashed rgba(168,184,217,0.35)",
                borderRadius: 3,
                bgcolor: "rgba(255,255,255,0.04)",
                color: "#fff",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.25,
                transition:
                    "background-color 160ms ease, border-color 160ms ease",
                "&:hover": {
                    bgcolor: "rgba(255,255,255,0.08)",
                    borderColor: "rgba(60,233,124,0.55)",
                },
            }}
        >
            <Box
                sx={{
                    width: 48,
                    height: 48,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "rgba(60,233,124,0.14)",
                    color: "#3CE97C",
                }}
            >
                <GridViewIcon sx={{ fontSize: 24 }} />
            </Box>
            <Typography
                sx={{ fontWeight: 700, fontSize: 16, lineHeight: 1.15 }}
            >
                Browse all
            </Typography>
            <Stack
                direction="row"
                sx={{ alignItems: "center", gap: 0.5, color: "#aab4c8" }}
            >
                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                    See every workout
                </Typography>
                <ArrowForwardIcon sx={{ fontSize: 15 }} />
            </Stack>
        </Box>
    );
}
